module.exports = __webpack_public_path__ + "img/Pic_LT_D.2ecbb265.png";